import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";
import { segmentIdentify, segmentTrack } from "../../helpers/segment";
import { scrollToTop } from "../../methods/scrollToTop";
import { updateWarriorAgreementSignature, updateWarriorAgreementStats } from "../../store/actions/users";
import AgreementModal from "../Auth/AgreementModal";

const useStyles = makeStyles((theme: any) => ({
  page: {
    height: "100vh",
    display: "grid",
    gridTemplateRows: "0px auto",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      height: "unset",
      minHeight: "100vh",
    },
  },
  root: {
    padding: theme.spacing(9, 3, 3, 3),
    background: "#eee",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 0, 3, 0),
    },
  },
  container: {
    maxWidth: 1200,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    border: "1px solid #eee",
    background: "#ffffff",
    borderRadius: 4,
    boxShadow: "0px 0px 2px 1px #ccc",
    boxSizing: "border-box",
    height: "calc(100vh - 200px)",
    overflow: "hidden",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      overflow: "unset",
      height: "100%",
    },
  },
  header: {},
  grid: {},
  textbox: {},
  graphic: {},
  label: {},
  link: {
    color: "blue",
    textDecoration: "none",
    cursor: "pointer",
  },
}));

const ProviderTermsList = () => {
  scrollToTop();
  const classes = useStyles();
  const [success, setSuccess] = useState("");
  const [check, setCheck] = useState(false);
  const { uid } = useSelector((state: any) => state.firebase.profile);
  const [providerId = null] = useQueryParam("id", StringParam);

  useEffect(() => {
    if (providerId) {
      if (!uid) {
        const overrideId: any = providerId;
        segmentIdentify({}, overrideId);
      }
      segmentTrack("Provider Terms Opened", { uid: providerId });
      updateWarriorAgreementStats(providerId);
    }
  }, []);

  const handleCheck = async () => {
    segmentTrack("Provider Terms Checked", { uid: providerId });
    await updateWarriorAgreementSignature(providerId);
    setSuccess("Received. Thank you!");
  };

  useEffect(() => {
    if (check) {
      handleCheck();
    }
  }, [check]);

  return (
    <div className={classes.page}>
      <div />
      <AgreementModal
        title="Policy Updates for Providers"
        subtext={
          <>
            <Typography>
              We have updated our
              <Link to={`/provider-agreement${providerId ? `?provider=${providerId}` : ""}`} target="_blank" className={classes.link}>
                {" "}
                Provider Agreement
              </Link>
              {" and our "}
              <Link to={`/service-provider-policy${providerId ? `?provider=${providerId}` : ""}`} target="_blank" className={classes.link}>
                Service Provider Policy
              </Link>
              {". "}Please review and click the checkbox below to continue working and partnering with Dimension.
            </Typography>
          </>
        }
        agreementCheck={check}
        setAgreementCheck={setCheck}
        setAgreement={null}
        rootClass={classes.root}
        modalClass={classes.container}
        hideButton={true}
        keepScroll={true}
        success={success}
      />
    </div>
  );
};

export default ProviderTermsList;
